module.exports = __webpack_public_path__ + "static/media/027-dentist.09e5428c.svg";